import React, { useRef, useState } from 'react';
import {
  Datagrid,
  TextField,
  useRefresh,
  useRecordContext,
  DateField,
  NumberField,
} from 'react-admin';

import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import InfoIcon from '@material-ui/icons/Info';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PrintIcon from '@material-ui/icons/Print';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { useSnackbar } from 'notistack';

import DialogoAutorizacao from '../../Components/Dialogos/DialogoAutorizacao';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import ListPageComum from '../../Components/ReactAdmin/List/ListPageComum';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api, imprimirNotaVenda } from '../../services';
import {
  formatCNPJ,
  formatCPF,
  podeConsultarDevolucaoNfce,
  podeConverterNfceParaNfe,
  podeReiniciarConversaoNfce,
  podeReprocessarDevolucaoNfce,
  temConversaoNfce,
  rotuloStatusDevolucaoNfce,
} from '../../utils';
import {
  PRIMARY_COLOR,
  STATUS_DEVOLUCAO_NFCE_PROCESSANDO,
  STATUS_DEVOLUCAO_NFCE_REJEITADA,
  STATUS_DEVOLUCAO_NFCE_INDEFINIDA,
  STATUS_DEVOLUCAO_NFCE_FALHA_DEFINITIVA,
  STATUS_EMISSAO_NFCE_PENDENTE,
  STATUS_EMISSAO_NFCE_AUTORIZADA,
  STATUS_EMISSAO_NFCE_AUTORIZADA_SEM_XML,
  STATUS_EMISSAO_NFCE_CANCELADA,
  STATUS_EMISSAO_NFCE_CONTINGENCIA,
  STATUS_EMISSAO_NFCE_CONTINGENCIA_ENVIADA,
  STATUS_EMISSAO_NFCE_DENEGADA,
  STATUS_EMISSAO_NFCE_INDEFINIDA,
  STATUS_EMISSAO_NFCE_PROCESSANDO,
  STATUS_EMISSAO_NFCE_REJEITADA,
  STATUS_EMISSAO_NFCE_DESCONHECIDO,
  STATUS_EMISSAO_NFCE_REJEITADA_DEFINITIVO,
  STATUS_EMISSAO_NFCE_REJEITADA_REPROCESSAMENTO,
  CONVERSAO_NFCE_HABILITADA,
} from '../../utils/constants';
import { PERMISSAO_TELA_NFCES_LISTAR } from '../../utils/dadosTelas';
//import Dialogo from './DialogoCreateEdit';
import DialogoShowVenda from '../Vendas/DialogoShow';
import DialogoConverterNfceParaNfe from './DialogoConverterNfceParaNfe';
import DialogoInfoConversaoNfe from './DialogoInfoConversaoNfe';
import DialogoLogs from './DialogoLogs';
import DialogoLogsRejeitada from './DialogoLogsRejeitada';
import Filter from './Filter';

const PermissionsExpand = ({ record }) => {
  if (!record) return null;

  const header = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: 16,
    marginBottom: 20,
  };

  const container = {
    padding: 20,
    background: '#fafafa',
    borderRadius: 8,
  };

  const timeline = {
    position: 'relative',
    marginLeft: 20,
    borderLeft: '2px solid #ddd',
    paddingLeft: 20,
  };

  const item = {
    position: 'relative',
    marginBottom: 20,
  };

  const dot = (color) => ({
    position: 'absolute',
    left: -30,
    top: 4,
    width: 12,
    height: 12,
    borderRadius: '50%',
    background: color,
  });

  const title = {
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 2,
  };

  const desc = {
    fontSize: 13,
    color: '#666',
  };

  const error = {
    ...desc,
    color: '#c62828',
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleString('pt-BR');
  };

  const card = {
    background: '#fff',
    padding: 14,
    borderRadius: 8,
    border: '1px solid #eee',
  };

  const label = {
    fontSize: 12,
    fontWeight: 600,
    color: '#666',
    marginBottom: 4,
    textTransform: 'uppercase',
  };

  const value = {
    fontSize: 15,
    fontWeight: 500,
    color: '#222',
    wordBreak: 'break-all',
  };

  const Info = ({ labelText, valueText }) => (
    <div style={card}>
      <div style={label}>{labelText}</div>
      <div style={value}>{valueText || '-'}</div>
    </div>
  );

  return (
    <div style={container}>
      {/* CABEÇALHO */}
      <div style={header}>
        <Info
          labelText="Chave de acesso"
          valueText={record.chave_acesso_nota_fiscal}
        />
        <Info labelText="Número NFC-e" valueText={record.numero_nfce} />
        <Info labelText="Série" valueText={record.serie_nfce} />
        <Info
          labelText="CPF / CNPJ Cliente"
          valueText={
            record.cpf
              ? formatCPF(record.cpf)
              : record.cnpj
              ? formatCNPJ(record.cnpj)
              : '-'
          }
        />
        <Info labelText="Protocolo" valueText={record.nProt} />
        {record.tentativas_emissao_nfce > 0 && (
          <Info
            labelText="Tentativas de emissão"
            valueText={record.tentativas_emissao_nfce}
          />
        )}
        {record.tentativas_emissao_contingencia_nfe > 0 && (
          <Info
            labelText="Tentativas de contingência"
            valueText={record.tentativas_emissao_contingencia_nfe}
          />
        )}
        {record.tentativas_reenvio_contingencia_nfce > 0 && (
          <Info
            labelText="Tentativas de reenvio contingência"
            valueText={record.tentativas_reenvio_contingencia_nfce}
          />
        )}
        {record.tentativas_download_xml > 0 && (
          <Info
            labelText="Tentativas de download XML"
            valueText={record.tentativas_download_xml}
          />
        )}
      </div>

      <div style={timeline}>
        <div style={item}>
          <div style={dot('#2196f3')} />
          <div style={title}>Emissão da NFC-e</div>
          <div style={desc}>Data: {formatDate(record.data_emissao)}</div>
        </div>

        {record.contingencia ? (
          <div style={item}>
            <div style={dot('#ff9800')} />
            <div style={title}>Entrou em Contingência</div>
            <div style={desc}>Data: {formatDate(record.data_contingencia)}</div>
            <div style={desc}>Motivo: {record.xJust || '-'}</div>
          </div>
        ) : null}

        {record.data_autorizacao ? (
          <div style={item}>
            <div style={dot('#4caf50')} />
            <div style={title}>NFC-e Autorizada</div>
            <div style={desc}>Data: {formatDate(record.data_autorizacao)}</div>
            <div style={desc}>Protocolo: {record.protocolo || '-'}</div>
          </div>
        ) : null}

        {record.erro_sefaz && (
          <div style={item}>
            <div style={dot('#f44336')} />
            <div style={title}>Erro retornado pela SEFAZ</div>
            <div style={error}>{record.erro_sefaz}</div>
          </div>
        )}

        {record.erro_sefaz ? (
          <div style={item}>
            <div style={dot('#f44336')} />
            <div style={title}>Erro retornado pela SEFAZ</div>
            <div style={error}>{record.erro_sefaz}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const StatusField = (props) => {
  const record = useRecordContext(props);
  const venda = record ? record.record || null : null;
  const status_emissao_nfce = venda ? venda.status_emissao_nfce : null;

  let color = '';
  let backgroundColor = '';
  let label = '';

  // Conversão NFC-e -> NF-e em andamento: o status da devolução tem prioridade
  // sobre o status de emissão (que segue 'autorizada' durante todo o processo).
  if (venda && venda.devolucao_nfce) {
    label = rotuloStatusDevolucaoNfce(venda.status_devolucao_nfce);

    switch (venda.status_devolucao_nfce) {
      case STATUS_DEVOLUCAO_NFCE_PROCESSANDO: {
        color = '#0c5460';
        backgroundColor = '#d1ecf1';
        break;
      }
      case STATUS_DEVOLUCAO_NFCE_REJEITADA:
      case STATUS_DEVOLUCAO_NFCE_FALHA_DEFINITIVA: {
        color = '#721c24';
        backgroundColor = '#f5c6cb';
        break;
      }
      case STATUS_DEVOLUCAO_NFCE_INDEFINIDA: {
        color = '#6c757d';
        backgroundColor = '#e2e3e5';
        break;
      }
      default: {
        color = '#856404';
        backgroundColor = '#fff3cd';
        break;
      }
    }

    return (
      <Chip
        size="small"
        label={label}
        title={venda.erro_devolucao_nfce || undefined}
        style={{
          backgroundColor,
          color,
          fontWeight: 600,
        }}
      />
    );
  }

  switch (status_emissao_nfce) {
    case STATUS_EMISSAO_NFCE_PENDENTE: {
      color = '#856404';
      backgroundColor = '#fff3cd';
      label = 'Pendente';
      break;
    }

    case STATUS_EMISSAO_NFCE_PROCESSANDO: {
      color = '#0c5460';
      backgroundColor = '#d1ecf1';
      label = 'Processando';
      break;
    }

    case STATUS_EMISSAO_NFCE_AUTORIZADA: {
      color = '#155724';
      backgroundColor = '#d4edda';
      label = 'Autorizada';
      break;
    }

    case STATUS_EMISSAO_NFCE_AUTORIZADA_SEM_XML: {
      color = '#004085';
      backgroundColor = '#cce5ff';
      label = 'Autorizada sem XML';
      break;
    }

    case STATUS_EMISSAO_NFCE_CONTINGENCIA: {
      color = '#856404';
      backgroundColor = '#fff3cd';
      label = 'Contingência';
      break;
    }

    case STATUS_EMISSAO_NFCE_CONTINGENCIA_ENVIADA: {
      color = '#856404';
      backgroundColor = '#ffeeba';
      label = 'Contingência enviada';
      break;
    }

    case STATUS_EMISSAO_NFCE_CANCELADA: {
      color = '#383d41';
      backgroundColor = '#e2e3e5';
      label = 'Cancelada';
      break;
    }

    case STATUS_EMISSAO_NFCE_DENEGADA: {
      color = '#721c24';
      backgroundColor = '#f8d7da';
      label = 'Denegada';
      break;
    }

    case STATUS_EMISSAO_NFCE_REJEITADA: {
      color = '#721c24';
      backgroundColor = '#f5c6cb';
      label = 'Rejeitada';
      break;
    }

    case STATUS_EMISSAO_NFCE_REJEITADA_DEFINITIVO: {
      color = '#721c24';
      backgroundColor = '#f5c6cb';
      label = 'Rejeitada Definitivo';
      break;
    }

    case STATUS_EMISSAO_NFCE_INDEFINIDA: {
      color = '#6c757d';
      backgroundColor = '#e2e3e5';
      label = 'Indefinida';
      break;
    }

    case STATUS_EMISSAO_NFCE_DESCONHECIDO: {
      color = '#6c757d';
      backgroundColor = '#e2e3e5';
      label = 'Desconhecido';
      break;
    }

    case STATUS_EMISSAO_NFCE_REJEITADA_REPROCESSAMENTO: {
      color = '#c28086';
      backgroundColor = '#b1a2a4';
      label = 'Rejeitada Reprocessamento';
      break;
    }

    default:
      break;
  }

  return (
    <Chip
      size="small"
      label={label}
      style={{
        backgroundColor,
        color,
        fontWeight: 600,
      }}
    />
  );
};

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: PRIMARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

//status_emissao_nfce

const List = (props) => {
  const refresh = useRefresh();
  const classes2 = useStyles();
  const refDialogoShowVenda = useRef(null);
  const refDialogoLogsRejeitada = useRef(null);
  const refDialogoLogs = useRef(null);
  const refDialogoConverter = useRef(null);
  const refDialogoInfoConversao = useRef(null);
  const refDialogoAutorizacaoReinicio = useRef(null);
  const [convertendoIds, setConvertendoIds] = useState(() => new Set());
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    refresh();
  };

  const toolbarActions = <ActionsList {...props} />;

  function handleShow(id) {
    if (refDialogoShowVenda.current) {
      refDialogoShowVenda.current.handleOpen(id);
    }
  }

  function cancelarVenda(dados) {}

  function liberarConversao(id) {
    setConvertendoIds((prev) => {
      const proximo = new Set(prev);
      proximo.delete(id);
      return proximo;
    });
  }

  function handleConverterNfceParaNfe(record) {
    if (refDialogoConverter.current) {
      // O diálogo carrega o cliente da venda (record.cliente_id) sozinho —
      // decide ali se precisa pedir escolha de cliente (venda anônima) ou
      // travar por cadastro incompleto perante a SEFAZ.
      refDialogoConverter.current.handleOpen(
        { id: record.id },
        record.cliente_id,
      );
    }
  }

  async function handleConfirmaConversao(
    { id },
    { revenda, cliente_id, autorizador_id },
  ) {
    // Desabilita o botão da linha já no clique, antes da resposta.
    setConvertendoIds((prev) => new Set(prev).add(id));

    try {
      const { data } = await api.post(`/fiscal_nfces/${id}/converter-nfe`, {
        revenda,
        autorizador_id,
        ...(cliente_id && { cliente_id }),
      });

      if (data.status) {
        enqueueSnackbar('Conversão iniciada — acompanhe o status da nota.', {
          variant: 'success',
        });
        // Sucesso: refresh traz o status novo (devolucao_nfce=true /
        // status_devolucao_nfce atualizado) e o show() da ação reavalia; libera
        // aqui também para não deixar a linha "morta" se ela voltar elegível de
        // novo (ex. reprocessamento de uma rejeitada anterior).
        liberarConversao(id);
      } else {
        enqueueSnackbar(data.message || 'Não foi possível converter a NFC-e.', {
          variant: 'error',
        });
        liberarConversao(id);
      }
    } catch (e) {
      enqueueSnackbar('Erro ao converter a NFC-e. Tente novamente.', {
        variant: 'error',
      });
      liberarConversao(id);
    } finally {
      refresh();
    }
  }

  // Antecipa a consulta à SEFAZ de uma devolução `indefinida` (o worker já
  // consulta sozinho a cada ciclo). Só enfileira; não muda o estado.
  async function handleConsultarDevolucao(record) {
    setConvertendoIds((prev) => new Set(prev).add(record.id));

    try {
      const { data } = await api.post(
        `/fiscal_nfces/${record.id}/consultar-devolucao`,
      );

      enqueueSnackbar(data.message || 'Consulta enfileirada.', {
        variant: data.status ? 'success' : 'error',
      });
    } catch (e) {
      enqueueSnackbar('Erro ao consultar a devolução. Tente novamente.', {
        variant: 'error',
      });
    } finally {
      liberarConversao(record.id);
      refresh();
    }
  }

  // "Reiniciar conversão" (falha definitiva) também exige a digital do gerente.
  function handleReiniciarConversao(record) {
    if (refDialogoAutorizacaoReinicio.current) {
      refDialogoAutorizacaoReinicio.current.handleOpen(record.id);
    }
  }

  async function handleConfirmaReinicio(autorizadorId, _dados, id) {
    setConvertendoIds((prev) => new Set(prev).add(id));

    try {
      const { data } = await api.post(
        `/fiscal_nfces/${id}/reiniciar-devolucao`,
        { autorizador_id: autorizadorId },
      );

      enqueueSnackbar(
        data.message ||
          (data.status
            ? 'Conversão reiniciada.'
            : 'Não foi possível reiniciar a conversão.'),
        { variant: data.status ? 'success' : 'error' },
      );
    } catch (e) {
      enqueueSnackbar('Erro ao reiniciar a conversão. Tente novamente.', {
        variant: 'error',
      });
    } finally {
      liberarConversao(id);
      refresh();
    }
  }

  async function concertarRejeitada(dados) {
    const response = await api.put(`/reprocessar_nfce_rejeitada/${dados.id}`);

    const { status, data } = response.data;

    if (status) {
      if (data) {
        if (refDialogoLogs.current) {
          refDialogoLogs.current.handleOpen(
            {
              retorno: JSON.stringify(data.retorno, null, 2),
              envio: JSON.stringify(data.nfce, null, 2),
              inutilizacao: JSON.stringify(data.responseInutilizacao, null, 2),
            },
            dados,
          );
        }
      }
    } else {
      enqueueSnackbar('erro doido', {
        variant: 'error',
      });
    }

    refresh();
  }

  //calcular custo das emissoes do mes
  //painel

  function parsificar(dados) {
    let parsed = dados;
    try {
      while (typeof parsed === 'string') {
        parsed = JSON.parse(parsed);
      }
    } catch {
      // 🔥 se falhar, provavelmente é stringificado
      //parsed = JSON.parse(JSON.parse(dados));
    }

    return parsed;
  }

  async function verLogsRejeitadas(dados) {
    const response = await api.get(`/logs_nfce_rejeitada/${dados.id}`);
    const { retorno, envio, erro } = response.data;

    if (refDialogoLogsRejeitada.current) {
      refDialogoLogsRejeitada.current.handleOpen(
        {
          retorno: JSON.stringify(parsificar(retorno), null, 2),
          envio: JSON.stringify(parsificar(envio), null, 2),
          erro: JSON.stringify(parsificar(erro), null, 2),
        },
        dados,
      );
    }
  }

  const renderGrid = ({ listProps, classes, listContext, ...rest }) => (
    <>
      <Datagrid {...props} {...rest}>
        <StatusField
          label="Status Emissão"
          source="status_emissao_nfce"
          sortable={false}
          headerClassName={classes2.dataHeader}
          cellClassName={classes2.dataCell}
        />
        <TextField
          source="id"
          label="Id da Venda"
          headerClassName={classes2.dataHeader}
          cellClassName={classes2.dataCell}
          sortable={false}
        />
        <TextField
          source="numero"
          label="Número da Venda"
          headerClassName={classes2.dataHeader}
          cellClassName={classes2.dataCell}
          sortable={false}
        />
        <DateField
          source="data"
          label="Data da Venda"
          showTime
          headerClassName={classes2.dataHeader}
          cellClassName={classes2.dataCell}
        />
        <DateField
          source="data_emissao"
          label="Data da Emissão"
          showTime
          headerClassName={classes2.dataHeader}
          cellClassName={classes2.dataCell}
        />
        <NumberField
          source="valor"
          locales="pt-BR"
          options={{
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            style: 'currency',
            currency: 'BRL',
          }}
          label="Valor Total"
          headerClassName={classes2.dataHeader}
          cellClassName={classes2.dataCell}
        />
        <ActionsField
          textAlign="right"
          label="Ações"
          sortable={false}
          headerClassName={classes2.dataHeader}
          cellClassName={classes2.dataCell}
          actions={[
            {
              title: 'Imprimir Danfe',
              icon: <PrintIcon />,
              onClick: async (r) => {
                const codigo = await imprimirNotaVenda(r.id);
              },
            },
            {
              title: 'Detalhes da Venda',
              icon: <VisibilityIcon />,
              onClick: async (r) => {
                handleShow(r.id);
              },
            },
            /* {
              title: 'Cancelar Venda',
              icon: <CancelIcon />,
              onClick: async (r) => {
                cancelarVenda(r);
              },
              disabled: () => false,
            }, */
            {
              title: 'Reprocessar Rejeitada',
              icon: <ReplayIcon />,
              onClick: async (r) => {
                concertarRejeitada(r);
              },
              disabled: () => true,
              show: (r) =>
                r.status_emissao_nfce === STATUS_EMISSAO_NFCE_REJEITADA,
            },
            {
              title: 'Logs da Rejeição',
              icon: <ListAltIcon />,
              onClick: async (r) => {
                verLogsRejeitadas(r);
              },
              disabled: () => false,
              show: (r) =>
                r.status_emissao_nfce === STATUS_EMISSAO_NFCE_REJEITADA,
            },
            {
              title: 'Converter NFC-e em NF-e',
              icon: <SwapHorizIcon />,
              onClick: (r) => handleConverterNfceParaNfe(r),
              disabled: (r) => convertendoIds.has(r.id),
              show: (r) =>
                CONVERSAO_NFCE_HABILITADA && podeConverterNfceParaNfe(r),
            },
            {
              title: 'Reprocessar devolução',
              icon: <ReplayIcon />,
              onClick: (r) => handleConverterNfceParaNfe(r),
              disabled: (r) => convertendoIds.has(r.id),
              show: (r) => podeReprocessarDevolucaoNfce(r),
            },
            {
              title: 'Consultar devolução na SEFAZ',
              icon: <SearchIcon />,
              onClick: (r) => handleConsultarDevolucao(r),
              disabled: (r) => convertendoIds.has(r.id),
              show: (r) => podeConsultarDevolucaoNfce(r),
            },
            {
              title: 'Reiniciar conversão',
              icon: <AutorenewIcon />,
              onClick: (r) => handleReiniciarConversao(r),
              disabled: (r) => convertendoIds.has(r.id),
              show: (r) => podeReiniciarConversaoNfce(r),
            },
            {
              title: 'Detalhes da conversão',
              icon: <InfoIcon />,
              onClick: (r) => {
                if (refDialogoInfoConversao.current) {
                  refDialogoInfoConversao.current.handleOpen(r.id);
                }
              },
              disabled: () => false,
              show: (r) => temConversaoNfce(r),
            },
          ]}
        />
      </Datagrid>
      <DialogoShowVenda ref={refDialogoShowVenda} />
      <DialogoLogsRejeitada ref={refDialogoLogsRejeitada} />
      <DialogoLogs ref={refDialogoLogs} />
      <DialogoConverterNfceParaNfe
        ref={refDialogoConverter}
        handleConfirma={handleConfirmaConversao}
      />
      <DialogoInfoConversaoNfe ref={refDialogoInfoConversao} />
      <DialogoAutorizacao
        ref={refDialogoAutorizacaoReinicio}
        usar_biometria
        title="Autorizar reinício da conversão"
        enqueueSnackbar={enqueueSnackbar}
        mensagemSucesso="Reinício autorizado."
        handleSalvar={handleConfirmaReinicio}
      />
    </>
  );

  return (
    <ProtegerPagina permissao={PERMISSAO_TELA_NFCES_LISTAR}>
      <ListPageComum
        title="NFCEs"
        filters={<Filter />}
        toolbarActions={toolbarActions}
        renderGrid={(props) =>
          renderGrid({ ...props, expand: <PermissionsExpand /> })
        }
        perPage={50}
        sort={{ field: 'data', order: 'DESC' }}
        listProps={props}
        filter={{ tipoNota: 'nfce' }}
        filterDefaultValues={{
          periodo: {
            start: new Date(),
            end: new Date(),
          },
        }}
      />
    </ProtegerPagina>
  );
};

export default List;
